import { useState } from 'react';

interface UseFormStateReturn {
  loading: boolean;
  error: string;
  setLoading: (loading: boolean) => void;
  setError: (error: string) => void;
  clearError: () => void;
}

export const useFormState = (): UseFormStateReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const clearError = () => setError("");

  return {
    loading,
    error,
    setLoading,
    setError,
    clearError
  };
};
